import React from "react";
import { Alert, AlertTitle, Button } from "@mui/material";

import { Progress } from "ui";

import { useCustomWorkflow } from "fond/hooks/useCustomWorkflow";
import { Maybe } from "fond/types";

interface GeneratePanelProps {
  versionId: Maybe<string>;
}

const stageConfig: Record<string, { label: string }> = {
  c2s: { label: "Calculating cost to serve" },
};

const GeneratePanel: React.FC<GeneratePanelProps> = ({ versionId }) => {
  const { workflowState, stages, runWorkflow } = useCustomWorkflow({
    versionId: versionId ?? undefined,
    key: "collaboration_cost_to_serve",
  });
  const isGenerating = workflowState === "STARTING" || workflowState === "IN_PROGRESS";

  const handleGenerate = async () => {
    runWorkflow?.();
  };

  return (
    <>
      {workflowState === undefined && (
        <Alert severity="info" variant="compact" sx={{ mb: 1 }}>
          Cost to serve outputs are ready.
        </Alert>
      )}

      {workflowState === "COMPLETE" && (
        <Alert severity="success" variant="compact" sx={{ mb: 1 }}>
          Cost to serve outputs generated.
        </Alert>
      )}

      {workflowState === "ERROR" && (
        <Alert severity="error" variant="compact" sx={{ mb: 2 }}>
          <AlertTitle>Cost to Serve failed</AlertTitle>
          Cost to serve outputs could not be generated.
        </Alert>
      )}

      {(isGenerating || workflowState === "ERROR") && (
        <>
          <Alert severity="info" variant="compact" sx={{ mb: 1 }}>
            Generating cost to serve.
          </Alert>
          {stages ? (
            <Progress steps={stages.map(({ key, status }) => ({ ID: key, Label: stageConfig[key].label, Status: status }))} />
          ) : (
            <Progress steps={[{ ID: "preparing", Label: "Preparing", Status: "InProgress" }]} />
          )}
        </>
      )}

      {!isGenerating && (
        <Button fullWidth variant="contained" size="small" sx={{ mt: 2 }} disabled={!runWorkflow || isGenerating} onClick={handleGenerate}>
          {workflowState === "COMPLETE" ? "Regenerate" : "Generate"} Cost to Serve
        </Button>
      )}
    </>
  );
};

export default GeneratePanel;
